var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 17.5007L2.13564 16.876L1.63588 17.5007L2.13564 18.1253L2.9165 17.5007ZM16.0415 18.5007C16.5938 18.5007 17.0415 18.0529 17.0415 17.5007C17.0415 16.9484 16.5938 16.5007 16.0415 16.5007V17.5007V18.5007ZM8.74984 10.209L7.96897 9.58429L2.13564 16.876L2.9165 17.5007L3.69737 18.1253L9.53071 10.8337L8.74984 10.209ZM2.9165 17.5007L2.13564 18.1253L7.96897 25.417L8.74984 24.7923L9.53071 24.1676L3.69737 16.876L2.9165 17.5007ZM2.9165 17.5007V18.5007H16.0415V17.5007V16.5007H2.9165V17.5007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 11.8584V9.22119C14.5835 7.60285 14.5835 6.79368 15.0575 6.23419C15.5314 5.6747 16.3296 5.54167 17.9259 5.27562L25.0971 4.08041C28.3402 3.5399 29.9617 3.26964 31.0226 4.16834C32.0835 5.06703 32.0835 6.71095 32.0835 9.99878V24.9999C32.0835 28.2878 32.0835 29.9317 31.0226 30.8304C29.9617 31.7291 28.3402 31.4588 25.0971 30.9183L17.9259 29.7231C16.3296 29.457 15.5314 29.324 15.0575 28.7645C14.5835 28.205 14.5835 27.3958 14.5835 25.7775V23.4289",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.ff8907c1faff95c938874fabc540b1f5.svg";
export { ForwardRef as ReactComponent };